export type StaticAsset = string | { src: string; width?: number; height?: number }

export function resolveAssetSrc(asset: StaticAsset): string {
  return typeof asset === "string" ? asset : asset.src
}
